import React, { useState } from "react";
import { Tab, Tabs, Container } from "react-bootstrap";
import { onExport } from "utils/helper";
import UnMappedNDCTable from "./UnMappedNDCTable";
import HiddenNDCTable from "./HiddenNDCTable";

const NDCTable = (props) => {
  const {
    maping,
    setMaping,
    collapseSider,
    toggleSider,
    Ndcflag,
    setNdcflag,
    NdccolumnFilters,
    onPageChangeNdc,
    handleSearchNdcColumnFilters,
    loading,
    setLoading,
    crosswalkNdcsearch,
    setNdcTableData,
    NdcTableData,
    NdcTotalrecords,
    Ndcrefetc,
    ndckey,
    setNdckey,
    orgId,
    setNdcPurchaseHistoryData,
    setNDCMapingHistoryData,
    setndcDetails,
    ndcPurchaseHistoryRecords,
    setNdcPurchaseHistoryRecords,
    selectedndcpurchaseData,
    setSelectedNdcPurchaseData,
    MapingHistoryinstialValues,
    searchNdcCode,
    setSearchChargeCode,
    resetFilterFlag,
    SetResetFilterFlag,
  } = props;
  const [reset, setReset] = useState(false);

  const [unmappedchargodesize, setUnmappedChargeCodeSize] = useState(0);
  const [hiddenrecords, setTotalHideRecords] = useState(0);

  const onKeyChange = (k) => {
    if (k == "unmappedndc") {
      Ndcrefetc(true);
    }
    setNdckey(k);
    setReset(!reset);
    SetResetFilterFlag(true);
  };

  return (
    <>
      <div>
        <div fluid className="bin_info my-0">
          <div
            className=""
            // hidden={collapseSider}
          >
            <div className="card-body p-0">
              <Tabs
                id="controlled-tab-example"
                activeKey={ndckey}
                onSelect={(k) => onKeyChange(k)}
                className="mb-3"
              >
                <Tab
                  eventKey="unmappedndc"
                  title={`${"Unmapped NDCs"} ${
                    ndckey == "unmappedndc" ? `(${NdcTotalrecords})` : ""
                  }`}
                >
                  <UnMappedNDCTable
                    Ndcflag={Ndcflag}
                    setNdcflag={setNdcflag}
                    toggleSider={toggleSider}
                    collapseSider={collapseSider}
                    NdcTableData={NdcTableData}
                    NdccolumnFilters={NdccolumnFilters}
                    onPageChange={onPageChangeNdc}
                    onSearchColumnFilters={handleSearchNdcColumnFilters}
                    loading={loading}
                    setLoading={setLoading}
                    crosswalkNdcsearch={crosswalkNdcsearch}
                    setNdcTableData={setNdcTableData}
                    NdcTotalrecords={NdcTotalrecords}
                    refetch={Ndcrefetc}
                    orgId={orgId}
                    setNdcPurchaseHistoryData={setNdcPurchaseHistoryData}
                    setNDCMapingHistoryData={setNDCMapingHistoryData}
                    setndcDetails={setndcDetails}
                    ndcPurchaseHistoryRecords={ndcPurchaseHistoryRecords}
                    setNdcPurchaseHistoryRecords={setNdcPurchaseHistoryRecords}
                    selectedndcpurchaseData={selectedndcpurchaseData}
                    setSelectedNdcPurchaseData={setSelectedNdcPurchaseData}
                    MapingHistoryinstialValues={MapingHistoryinstialValues}
                    resetFilterFlag={resetFilterFlag}
                    SetResetFilterFlag={SetResetFilterFlag}
                  />
                </Tab>
                <Tab
                  eventKey="hidendcs"
                  title={`${"Hidden NDCs"} ${
                    ndckey == "hidendcs" ? `(${hiddenrecords})` : ""
                  }`}
                >
                  <HiddenNDCTable
                    ndckey={ndckey}
                    orgId={orgId}
                    setTotalHideRecords={setTotalHideRecords}
                    hiddenrecords={hiddenrecords}
                    crosswalkNdcsearch={crosswalkNdcsearch}
                    setLoading={setLoading}
                    toggleSider={toggleSider}
                    collapseSider={collapseSider}
                    searchNdcCode={searchNdcCode}
                    setSearchChargeCode={setSearchChargeCode}
                    resetFilterFlag={resetFilterFlag}
                    SetResetFilterFlag={SetResetFilterFlag}
                  />
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NDCTable;
